const textFieldLogin = {
  email: 'Email',
  password: 'Contraseña'
};

export default textFieldLogin;
